import { Injectable } from '@angular/core';
import { Opportunity } from '@vendasta/sales-opportunities';
import { OpportunityService } from '../../opportunity.service';
import { Observable, ReplaySubject } from 'rxjs';

export type Mode = 'details' | 'qualification';

@Injectable()
export class OpportunityDetailsService {
  private readonly mode$$ = new ReplaySubject<Mode>(1);
  public readonly mode$ = this.mode$$.asObservable();
  readonly isOpen$: Observable<boolean>;

  constructor(private readonly opportunityUpdates: OpportunityService) {}
  setSelectedOpportunity(opportunity: Opportunity): void {
    this.setMode('details');
    this.opportunityUpdates.setSelectedOpportunity(opportunity);
  }

  setMode(mode: Mode): void {
    this.mode$$.next(mode);
  }
}
